import { toast } from 'react-semantic-toasts';

export const clipboardIconOnClick = async (copyText: string, inputName: string) => {
  await navigator.clipboard.writeText(copyText);

  toast({
    type: 'success',
    icon: 'check circle',
    title: 'Copied to Clipboard',
    description: `${inputName} has been copied to your clipboard`,
    time: 5000,
  });
};

export const getClipboardIcon = (copyText: string, inputName: string) => {
  return {
    name: 'clipboard',
    link: true,
    onClick: async () => {
      await clipboardIconOnClick(copyText, inputName);
    },
  };
};
